import {ViewType} from "../../../../../../../../core/gd/const/views/view-type"
import {
    AddView_Group,
    AddView_GroupCollaboration,
    AddView_GroupEmbed,
    AddView_GroupEvents,
    AddView_GroupMore,
    AddView_GroupPlanning,
    AddView_GroupTasks,
    AddView_GroupType,
    AddView_OptionConfig
} from "../../../../../../../../core/gd-ui/add-view/@types"
import {PROJECT_LIST_CONFIG} from "../../../../../../../../core/views/list/@config"
import AddViewPreviewDefaultForm from "../preview/forms/default-form"
import {PROJECT_TABLE_CONFIG} from "../../../../../../../../core/views/table/@config"
import {PROJECT_BOARD_CONFIG} from "../../../../../../../../core/views/board/@config"
import {EmbedType} from "../../../../../../../../core/gd/const/embed/embed-type"
import {PROJECT_CALENDAR_CONFIG} from "../../../../../../../../core/views/calendar/@config"
import {PROJECT_GANTT_CONFIG} from "../../../../../../../../core/views/gantt/@config"
import {PROJECT_WORKLOAD_CONFIG} from "../../../../../../../../core/views/workload/@config"
import {PROJECT_DOCS_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-docs"
import {PROJECT_PAGE_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-page"
import {PROJECT_FILES_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-files"
import {PROJECT_GOALS_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-goals"
import {PROJECT_DISCUSSION_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-discussion"
import {PROJECT_MEETINGS_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-meeting"
import {PROJECT_EXPENSES_CONFIG} from "../../../../../../../../core/views/expenses/@config"
import AddViewPreviewRequestForm from "../preview/forms/request-form"
import {PROJECT_DASHBOARD_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-dashboard"
import {PROJECT_ACTIVITY_CONFIG} from "../../../../../../../../core/views/activity/@config"
import {PROJECT_LINK_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-link"
import {EMBED_DEFAULT_CONFIG} from "../../../../../../../../core/gd/const/embed/configs/default"
import {Feature} from "../../../../../../../../core/gd/access-control/feature-access/const"
import AddViewPreviewDashboardForm from "../preview/forms/dashboard-form"
import AddViewPreviewLinkForm from "../preview/forms/link-form"
import AddViewPreviewEmbedForm from "../preview/forms/embed-form"
import {EMBED_FIGMA_CONFIG} from "../../../../../../../../core/gd/const/embed/configs/figma"
import {EMBED_GOOGLE_MAP_CONFIG} from "../../../../../../../../core/gd/const/embed/configs/google-map"
import {EMBED_YOUTUBE_CONFIG} from "../../../../../../../../core/gd/const/embed/configs/youtube"
import {EMBED_GOOGLE_CALENDAR_CONFIG} from "../../../../../../../../core/gd/const/embed/configs/google-calendar"
import {EMBED_GOOGLE_DOC_CONFIG} from "../../../../../../../../core/gd/const/embed/configs/google-doc"
import {EMBED_GOOGLE_SHEET_CONFIG} from "../../../../../../../../core/gd/const/embed/configs/google-sheet"
import {EMBED_GOOGLE_SLIDES_CONFIG} from "../../../../../../../../core/gd/const/embed/configs/google-slides"
import {EMBED_FACEBOOK_CONFIG} from "../../../../../../../../core/gd/const/embed/configs/facebook"
import {EMBED_TWITTER_CONFIG} from "../../../../../../../../core/gd/const/embed/configs/twitter"
import {PROJECT_REPORTS_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-reports";
import {featureAccess} from "../../../../../../../../core/gd/access-control/feature-access/feature-access"
import {PROJECT_SUMMARY_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-summary"
import {PROJECT_TABLE_MAP_CONFIG} from "../../../../../../../../core/gd/const/views/configs/dual-mode/project-map";
import {PROJECT_TIMELINE_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project-timeline"
import {
    PROJECT_WHITEBOARD_CONFIG
} from "../../../../../../../../core/gd/const/views/configs/project/project-whiteboard";
import {
    PROJECT_EVENTS_SUMMARY_CONFIG
} from "../../../../../../../../core/gd/const/views/configs/project/events-summary";
import {PROJECT_TODOS_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-todos";

export default function addView_projectConfig(projectId: ID):AddView_Group[] {

    const res: AddView_Group[] = []

    res.push({
        ...AddView_GroupTasks,
        items   : [
            {
                typeId          : ViewType.PROJECT_LIST,
                iconSvg         : PROJECT_LIST_CONFIG.iconSvg,
                title           : PROJECT_LIST_CONFIG.menuName,
                description     : PROJECT_LIST_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_TABLE,
                iconSvg         : PROJECT_TABLE_CONFIG.iconSvg,
                title           : PROJECT_TABLE_CONFIG.menuName,
                description     : PROJECT_TABLE_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_BOARD,
                iconSvg         : PROJECT_BOARD_CONFIG.iconSvg,
                title           : PROJECT_BOARD_CONFIG.menuName,
                description     : PROJECT_BOARD_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },

            {
                typeId          : ViewType.PROJECT_TABLE_MAP,
                iconSvg         : PROJECT_TABLE_MAP_CONFIG.iconSvg,
                title           : PROJECT_TABLE_MAP_CONFIG.menuName,
                description     : PROJECT_TABLE_MAP_CONFIG.description,
                isPro           : !featureAccess(Feature.MAP),
                proFeature      : Feature.MAP,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_TODOS,
                iconSvg         : PROJECT_TODOS_CONFIG.iconSvg,
                title           : PROJECT_TODOS_CONFIG.name,
                description     : PROJECT_TODOS_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm, // Need change !!!
            }
        ]
    })

    res.push({
        ...AddView_GroupEvents,
        items   : [
            {
                typeId          : ViewType.PROJECT_CALENDAR,
                iconSvg         : PROJECT_CALENDAR_CONFIG.iconSvg,
                title           : PROJECT_CALENDAR_CONFIG.name,
                description     : PROJECT_CALENDAR_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_TIMELINE,
                iconSvg         : PROJECT_TIMELINE_CONFIG.iconSvg,
                title           : PROJECT_TIMELINE_CONFIG.name,
                description     : PROJECT_TIMELINE_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_EVENTS_SUMMARY,
                iconSvg         : PROJECT_EVENTS_SUMMARY_CONFIG.iconSvg,
                title           : PROJECT_EVENTS_SUMMARY_CONFIG.name,
                description     : PROJECT_EVENTS_SUMMARY_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            }
        ]
    })

    // COLLABORATION

    res.push({
        ...AddView_GroupCollaboration,
        items       : [
            {
                typeId          : ViewType.PROJECT_FILES,
                iconSvg         : PROJECT_FILES_CONFIG.iconSvg,
                title           : PROJECT_FILES_CONFIG.name,
                description     : PROJECT_FILES_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_DOCS,
                iconSvg         : PROJECT_DOCS_CONFIG.iconSvg,
                title           : PROJECT_DOCS_CONFIG.name,
                description     : PROJECT_DOCS_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_GOALS,
                iconSvg         : PROJECT_GOALS_CONFIG.iconSvg,
                title           : PROJECT_GOALS_CONFIG.name,
                description     : PROJECT_GOALS_CONFIG.description,
                isPro           : !featureAccess(Feature.GOALS),
                proFeature      : Feature.GOALS,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_DISCUSSION,
                iconSvg         : PROJECT_DISCUSSION_CONFIG.iconSvg,
                title           : PROJECT_DISCUSSION_CONFIG.name,
                description     : PROJECT_DISCUSSION_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_MEETINGS,
                iconSvg         : PROJECT_MEETINGS_CONFIG.iconSvg,
                title           : PROJECT_MEETINGS_CONFIG.name,
                description     : PROJECT_MEETINGS_CONFIG.description,
                isPro           : !featureAccess(Feature.MEETINGS),
                proFeature      : Feature.MEETINGS,
                formComponent   : AddViewPreviewDefaultForm,
            }

        ]
    })

    // PLANNING
    res.push({
        ...AddView_GroupPlanning,
        items       : [
            {
                typeId          : ViewType.PROJECT_GANTT,
                iconSvg         : PROJECT_GANTT_CONFIG.iconSvg,
                title           : PROJECT_GANTT_CONFIG.name,
                description     : PROJECT_GANTT_CONFIG.description,
                isPro           : !gd.company.license.projectView(ViewType.PROJECT_GANTT),
                proFeature      : Feature.GANTT,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_WORKLOAD,
                iconSvg         : PROJECT_WORKLOAD_CONFIG.iconSvg,
                title           : PROJECT_WORKLOAD_CONFIG.name,
                description     : PROJECT_WORKLOAD_CONFIG.description,
                isPro           : !gd.company.license.projectView(ViewType.PROJECT_WORKLOAD),
                proFeature      : Feature.WORKLOAD,
                formComponent   : AddViewPreviewDefaultForm,
            }
        ]
    })

    // PROJECTS
    // res.push({
    //     ...AddView_GroupProject,
    //     items       : [
    //         {
    //             typeId          : ViewType.PROJECT_SUMMARY,
    //             iconSvg         : PROJECT_SUMMARY_CONFIG.iconSvg,
    //             title           : PROJECT_SUMMARY_CONFIG.name,
    //             description     : PROJECT_SUMMARY_CONFIG.description,
    //             isPro           : !gd.company.license.projectView(ViewType.PROJECT_SUMMARY),
    //             formComponent   : AddViewPreviewDefaultForm,
    //         },
    //     ]
    // })

    // DOCUMENTS

    // res.push({
    //     type        : AddView_GroupType.GROUP,
    //     id          : 'documents',
    //     icon        : 'i5-document',
    //     title       : 'Documents',
    //     items       : [
    //
    //         {
    //             typeId          : ViewType.PROJECT_PAGE,
    //             iconSvg         : PROJECT_PAGE_CONFIG.iconSvg,
    //             title           : PROJECT_PAGE_CONFIG.name,
    //             description     : PROJECT_PAGE_CONFIG.description,
    //             formComponent   : AddViewPreviewDefaultForm,
    //         },
    //     ]
    // })

    // res.push({type: AddView_GroupType.SEPARATOR})

    // FORMS

    const formViews: AddView_OptionConfig[] = []

    formViews.push({
        typeId          : ViewType.PROJECT_REQUEST_FORMS,
        iconSvg         : 'isvg-request',
        title           : 'Request',
        description     : 'Create internal request forms for your organization.',
        isPro           : !featureAccess(Feature.FORMS),
        proFeature      : Feature.FORMS,
        formParams      : {
            type        : 'request',
            projectId   : projectId
        },
        formComponent   : AddViewPreviewRequestForm
    })

    formViews.push({
        typeId          : ViewType.PROJECT_REQUEST_FORMS,
        iconSvg         : 'isvg-forms',
        title           : 'Public Form',
        description     : 'Create public forms for collecting external data and interactions.',
        isPro           : !featureAccess(Feature.FORMS),
        proFeature      : Feature.FORMS,
        formParams      : {
            type        : 'form',
            projectId   : projectId
        },
        formComponent   : AddViewPreviewRequestForm
    })

    if (formViews.length > 0) {
        res.push({
            type    : AddView_GroupType.GROUP,
            id      : 'forms',
            icon    : 'i5-request-forms',
            title   : 'Forms',
            items   : formViews
        })
    }


    // REPORTS

    res.push({
        title   : 'Progress & Reports',
        type    : AddView_GroupType.GROUP,
        id      : 'progress',
        icon    : 'i5-chart-bar',
        items   : [
            {
                typeId          : ViewType.PROJECT_ACTIVITY,
                iconSvg         : PROJECT_ACTIVITY_CONFIG.iconSvg,
                title           : PROJECT_ACTIVITY_CONFIG.name,
                description     : PROJECT_ACTIVITY_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_REPORTS,
                iconSvg         : PROJECT_REPORTS_CONFIG.iconSvg,
                title           : PROJECT_REPORTS_CONFIG.name,
                description     : PROJECT_REPORTS_CONFIG.description,
                isPro           : !featureAccess(Feature.REPORTS),
                proFeature      : Feature.REPORTS,
                formComponent   : AddViewPreviewDefaultForm,
            }
        ]
    })

    // FINANCE
    // res.push({
    //     ...AddView_GroupFinance,
    //     items       : [
    //
    //         gd.modules.expenses.enabled ? {
    //             typeId          : ViewType.PROJECT_EXPENSES,
    //             iconSvg         : PROJECT_EXPENSES_CONFIG.iconSvg,
    //             title           : PROJECT_EXPENSES_CONFIG.name,
    //             description     : PROJECT_EXPENSES_CONFIG.description,
    //             isPro           : !gd.company.license.projectView(ViewType.PROJECT_EXPENSES),
    //             proFeature      : Feature.EXPENSES,
    //             formComponent   : AddViewPreviewDefaultForm,
    //         } : null
    //
    //     ]
    // })

    // LINK / EMBED
    res.push({
        ...AddView_GroupEmbed,
        items       : _.compact([
            {
                typeId          : ViewType.PROJECT_LINK,
                iconSvg         : PROJECT_LINK_CONFIG.iconSvg,
                title           : PROJECT_LINK_CONFIG.name,
                description     : PROJECT_LINK_CONFIG.description,
                formComponent   : AddViewPreviewLinkForm,
            },
            {
                typeId          : ViewType.PROJECT_EMBED,
                iconSvg         : EMBED_DEFAULT_CONFIG.iconSvg,
                title           : EMBED_DEFAULT_CONFIG.name,
                description     : EMBED_DEFAULT_CONFIG.description,
                formParams      : {
                    embedType: EmbedType.DEFAULT
                },
                formComponent   : AddViewPreviewEmbedForm
            },
            {
                typeId          : ViewType.PROJECT_EMBED,
                iconSvg         : EMBED_FIGMA_CONFIG.iconSvg,
                title           : EMBED_FIGMA_CONFIG.name,
                description     : EMBED_FIGMA_CONFIG.description,
                formParams      : {
                    embedType: EmbedType.FIGMA
                },
                formComponent   : AddViewPreviewEmbedForm
            },
            {
                typeId          : ViewType.PROJECT_EMBED,
                iconSvg         : EMBED_GOOGLE_MAP_CONFIG.iconSvg,
                title           : EMBED_GOOGLE_MAP_CONFIG.name,
                description     : EMBED_GOOGLE_MAP_CONFIG.description,
                formParams      : {
                    embedType: EmbedType.GOOGLE_MAP
                },
                formComponent   : AddViewPreviewEmbedForm
            },
            {
                typeId          : ViewType.PROJECT_EMBED,
                iconSvg         : EMBED_YOUTUBE_CONFIG.iconSvg,
                title           : EMBED_YOUTUBE_CONFIG.name,
                description     : EMBED_YOUTUBE_CONFIG.description,
                formParams      : {
                    embedType: EmbedType.YOUTUBE
                },
                formComponent   : AddViewPreviewEmbedForm
            },
            {
                typeId          : ViewType.PROJECT_EMBED,
                iconSvg         : EMBED_GOOGLE_CALENDAR_CONFIG.iconSvg,
                title           : EMBED_GOOGLE_CALENDAR_CONFIG.name,
                description     : EMBED_GOOGLE_CALENDAR_CONFIG.description,
                formParams      : {
                    embedType: EmbedType.GOOGLE_CALENDAR
                },
                formComponent   : AddViewPreviewEmbedForm
            },
            {
                typeId          : ViewType.PROJECT_EMBED,
                iconSvg         : EMBED_GOOGLE_DOC_CONFIG.iconSvg,
                title           : EMBED_GOOGLE_DOC_CONFIG.name,
                description     : EMBED_GOOGLE_DOC_CONFIG.description,
                formParams      : {
                    embedType: EmbedType.GOOGLE_DOC
                },
                formComponent   : AddViewPreviewEmbedForm
            },
            {
                typeId          : ViewType.PROJECT_EMBED,
                iconSvg         : EMBED_GOOGLE_SHEET_CONFIG.iconSvg,
                title           : EMBED_GOOGLE_SHEET_CONFIG.name,
                description     : EMBED_GOOGLE_SHEET_CONFIG.description,
                formParams      : {
                    embedType: EmbedType.GOOGLE_SHEET
                },
                formComponent   : AddViewPreviewEmbedForm
            },
            {
                typeId          : ViewType.PROJECT_EMBED,
                iconSvg         : EMBED_GOOGLE_SLIDES_CONFIG.iconSvg,
                title           : EMBED_GOOGLE_SLIDES_CONFIG.name,
                description     : EMBED_GOOGLE_SLIDES_CONFIG.description,
                formParams      : {
                    embedType: EmbedType.GOOGLE_SLIDES
                },
                formComponent   : AddViewPreviewEmbedForm
            },
            {
                typeId          : ViewType.PROJECT_EMBED,
                iconSvg         : EMBED_FACEBOOK_CONFIG.iconSvg,
                title           : EMBED_FACEBOOK_CONFIG.name,
                description     : EMBED_FACEBOOK_CONFIG.description,
                formParams      : {
                    embedType: EmbedType.FACEBOOK
                },
                formComponent   : AddViewPreviewEmbedForm
            },
            {
                typeId          : ViewType.PROJECT_EMBED,
                iconSvg         : EMBED_TWITTER_CONFIG.iconSvg,
                title           : EMBED_TWITTER_CONFIG.name,
                description     : EMBED_TWITTER_CONFIG.description,
                formParams      : {
                    embedType: EmbedType.TWITTER
                },
                formComponent   : AddViewPreviewEmbedForm
            },
        ])
    })


    res.push({
        ...AddView_GroupMore,
        items       : _.compact([
            gd.modules.expenses.enabled ? {
                typeId          : ViewType.PROJECT_EXPENSES,
                iconSvg         : PROJECT_EXPENSES_CONFIG.iconSvg,
                title           : PROJECT_EXPENSES_CONFIG.name,
                description     : PROJECT_EXPENSES_CONFIG.description,
                isPro           : !gd.company.license.projectView(ViewType.PROJECT_EXPENSES),
                proFeature      : Feature.EXPENSES,
                formComponent   : AddViewPreviewDefaultForm,
            } : null


            ,
            {
                typeId          : ViewType.PROJECT_SUMMARY,
                iconSvg         : PROJECT_SUMMARY_CONFIG.iconSvg,
                title           : PROJECT_SUMMARY_CONFIG.name,
                description     : PROJECT_SUMMARY_CONFIG.description,
                isPro           : !gd.company.license.projectView(ViewType.PROJECT_SUMMARY),
                formComponent   : AddViewPreviewDefaultForm,
            },

        ])
    })

    //


    res.push({type: AddView_GroupType.SEPARATOR})



    // PAGE

    res.push({
        title           : 'Page',
        type            : AddView_GroupType.GROUP,
        id              : 'document',
        icon            : 'isvg-page-small',
        skipItemsList   : true,
        items           : [
            {
                typeId          : ViewType.PROJECT_PAGE,
                iconSvg         : PROJECT_PAGE_CONFIG.iconSvg,
                title           : PROJECT_PAGE_CONFIG.name,
                description     : PROJECT_PAGE_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
        ]
    })

    // WHITEBOARD
    res.push({
        title           : 'Whiteboard',
        type            : AddView_GroupType.GROUP,
        id              : 'whiteboard',
        icon            : 'isvg-whiteboard-small',
        skipItemsList   : true,
        items           : [
            {
                typeId          : ViewType.PROJECT_WHITEBOARD,
                iconSvg         : PROJECT_WHITEBOARD_CONFIG.iconSvg,
                title           : PROJECT_WHITEBOARD_CONFIG.name,
                description     : PROJECT_WHITEBOARD_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            }
        ]
    })

    // DASHBOARD
    res.push({
        title           : 'Dashboard',
        type            : AddView_GroupType.GROUP,
        id              : 'dashboard',
        // icon            : 'i5-dashboard',
        icon            : 'isvg-dashboard-small',
        skipItemsList   : true,
        items           : [
            {
                typeId          : ViewType.PROJECT_DASHBOARD,
                iconSvg         : PROJECT_DASHBOARD_CONFIG.iconSvg,
                title           : PROJECT_DASHBOARD_CONFIG.name,
                description     : PROJECT_DASHBOARD_CONFIG.description,
                formParams      : {
                    projectId: projectId
                },
                formComponent   : AddViewPreviewDashboardForm,
            }
        ]
    })




    return res
}

